module.exports = __webpack_public_path__ + "img/time-circle.f390459c.svg";